<div class="row">
    <div class="col-12">
     <h4 class="mb-2 py-1 font-header-1">FMS Agency</h4>
    </div>
 </div>
 
 <div class="row mb-2">
     <div class="col ">
         <div widget class="card border-0 box-shadow">
           
             <div class="card-body  widget-body pb-0 pt-2 mb-4">
                 <div class="row ">
                     <div class="col-2 ps-1 me-2 mt-4">
                         <button type="button" class="btn blue-btn btn-sm" data-bs-toggle="modal"
                             data-bs-target="#Createmodal"
                             (click)="CreateorUpdateFms('CreateFmsModal')"  
                             *ngIf="fp.fmsagencycreate">Add FMS agency
                             </button>
                     </div>
                     <div class="col-6 ps-1">
                            <span class="col"><label>Status&nbsp;</label>
                                <ng-select   [(ngModel)]="getfmsagency.statusLid" (change)="getFmsFilter()" style="width: 20%;"
                                  [clearable]="false" [searchable]="true" [items]="statusList" bindLabel="lovName" bindValue="id">
                                </ng-select>
                            </span>
                     </div>
                     <div class="col-3 ps-1 mt-4 ms-6 ">
                            <button type="button" class="btn btn-sm text-right" (click)="Refresh()">
                               <i class="fa fa-repeat"> </i>Refresh
                             </button>
                    </div>
                     
                 </div>
                 <!--========================================= ejs-grid ===================================================-->
    <div class="row mb-2 mt-2" style="min-height: 500px;">
     <div class="col ps-1">
         <ejs-grid #grid  [dataSource]='Grid | async' 
         [allowPaging]='true'
         [pageSettings]='initialPage' [filterSettings]='filterSettings' [allowFiltering]='true'
         [showColumnChooser]='true'
         [allowResizing]='true' [allowSorting]='true'  (dataStateChange)='dataChangeFms($event)'
         (actionBegin)="onActionFms($event)" >
             <e-columns>
                 <e-column width=100 headerText="Actions" [showInColumnChooser]='false'>
                     <ng-template #template let-data>
                         <button class="btn btn-edit-table" data-bs-toggle="modal" data-bs-target="#Createmodal" *ngIf="fp.fmsagencyupdate"   [disabled]="!(data?.agencyId) && (global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
                                  global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000') "  
                             (click)="CreateorUpdateFms('UpdateFmsModal');getDetails(data)"><i
                                 class="fa fa-edit"  
                                 ></i></button>&nbsp;
                         <button class="btn btn-delete-table" data-bs-toggle="modal" *ngIf="fp.fmsagencydelete"    [disabled]="!(data?.agencyId) && (global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
                                    global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000') "  
                             data-bs-target="#DeleteFmsmodal" (click)="getDetails(data)"><i
                                 class="fa fa-trash" 
                                 ></i></button>
                     </ng-template>
                 </e-column>
                 <e-column field="statusLovName" headerText="Status" width="150" type="string">
                </e-column>
                 <e-column width=150 field="providerName" headerText="Provider Name" type="string">
                     <ng-template #filterTemplate let-data>
                         <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                     </ng-template>
                 </e-column>
 
                 <e-column width=150 field="npi" headerText="NPI" type="string">
                     <ng-template #filterTemplate let-data>
                         <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                     </ng-template>
                 </e-column>
                 <e-column width=150 field="phoneNumber" headerText="Phone Number" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width=150 field="address" headerText="Address" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width=150 field="city" headerText="City" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width=150 field="state" headerText="State" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width=150 field="zipCode" headerText="Zip Code" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width=150 field="contactName" headerText="Contact Name" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width=150 field="email" headerText="Email" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width=150 field="fax" headerText="Fax" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column width=150 field="fmsFee" headerText="FMS Fee" type="Number">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                 <e-column width="50" [showInColumnChooser]='false'>
                     <ng-template #headerTemplate let-data>
                         <div>
                             <span id='show'(click)='showLocationColumns()' ><i class="fa fa-cog fa-lg" aria-hidden="true">
                                 </i></span>
                         </div>
                     </ng-template>
                 </e-column>
             </e-columns>
         </ejs-grid>
     </div> 
      </div>
             
    </div>
        
</div>
     </div>
 </div>
 
 <!-- For Create or Update Modal -->
 <span id="openListModal" data-bs-toggle="modal" data-bs-target="#Createmodal"></span>
 <div class="modal fade" id="Createmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     aria-hidden="true" data-bs-backdrop="static">
     <div class="modal-dialog create-update-zip" role="document">
         <div class="modal-content">
             <div class="modal-header">
                 <h5 class="modal-title font-header" id="exampleModalLabel"><span
                         *ngIf="FmsType == 'CreateFmsModal'"> Create
                         FMS Agency</span>
                     <span *ngIf="FmsType == 'UpdateFmsModal'">Update FMS Agency</span>
                 </h5>
                 <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" 
                 >
                     <span aria-hidden="true"></span>
                 </button>
             </div>
             <div class="modal-body">
                 <form [formGroup]="FmsForm">
                    <div class="row">
                        <div class="col-lg-5">
                            <label>Status<sup class="super-script">*</sup>
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <select class="form-control"formControlName="statusLid" [(ngModel)]="savefmsagecy.statusLId" >
                                <option *ngFor="let st of statusListItem" [value]="st.Key">
                                  {{ st.Value }}
                                </option>
                              </select>
                        </div>
                    </div>
                     <div class="row  mt-1">
                         <div class="col-lg-5">
                             <label>Provider Name<sup class="super-script">*</sup>
                             </label>
                         </div>
                         <div class="col-lg-7">
                             <input type="text" formControlName="providerName" class="form-control"
                                 [(ngModel)]="savefmsagecy.providerName" />
                         </div>
                     </div>
                     <div class="row mt-1">
                         <div class="col-lg-5">
                             <label>NPI
                             </label>
                         </div>
                         <div class="col-lg-7">
                             <input type="text" formControlName="npi" class="form-control" 
                              [(ngModel)]="savefmsagecy.npi" />
                        
                         </div>
                     </div>
                     <div class="row mt-1">
                        <div class="col-lg-5">
                            <label>Phone Number
                            </label>
                        </div>
                        <div class="col-lg-7">
       
                                <input type="text" min="0" max="99999999999999" class="form-control" id="phone" formControlName="phoneNumber" [(ngModel)]="savefmsagecy.phoneNumber" name="phone" (ngModelChange)="DemographicPhoneFormat()" (keypress)="numberOnly($event)" maxlength="14" />
                                <span class="error"
                                *ngIf="FmsForm.controls['phoneNumber'].invalid">
                               <p>*Enter Valid number, Enter 10 digit</p>
                                        </span>
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-lg-5">
                            <label>Address
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" formControlName="address" class="form-control"
                                [(ngModel)]="savefmsagecy.address" />
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-lg-5">
                            <label>City
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" formControlName="city" class="form-control"
                                [(ngModel)]="savefmsagecy.city" />
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-lg-5">
                            <label>State
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <ng-select [items]="stateList" [searchable]="true" 
                            [(ngModel)]="savefmsagecy.state" [clearable]="true" bindLabel="name" bindValue="abbreviation"
                            formControlName="state"></ng-select>
                            
                        </div>
                        
                    </div>
                    <div class="row mt-1">
                        <div class="col-lg-5">
                            <label>Zip Code
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text"  class="form-control" formControlName="zipCode" class="form-control"
                            maxlength="8" minlength="5"  (keypress)="keyPress($event)" 
                                [(ngModel)]="savefmsagecy.zipCode" />
                                <span class="error"
                                 *ngIf="FmsForm.controls['zipCode'].touched && FmsForm.controls['zipCode'].invalid">
                              <p>*Enter Valid zip, Enter 5 digits</p>
                              </span>
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-lg-5">
                            <label>Contact Name
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" formControlName="contactName" class="form-control"
                                [(ngModel)]="savefmsagecy.contactName" />
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-lg-5">
                            <label>Email
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" formControlName="email" class="form-control"
                                [(ngModel)]="savefmsagecy.email" />
                                <span class="error"
                              *ngIf="FmsForm.controls['email'].invalid">
                             <p>*Enter Valid Email</p>
                                      </span>
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-lg-5">
                            <label>Fax
                            </label>
                        </div>
                        <div class="col-lg-7">
                                <input type="text" min="0" max="99999999999999" class="form-control" id="fax" formControlName="fax" [(ngModel)]="savefmsagecy.fax" name="Fax" (ngModelChange)="DemographicPhoneFormat1()" (keypress)="numberOnly($event)" maxlength="14" />
                                <span class="error"
                              *ngIf="FmsForm.controls['fax'].invalid">
                             <p>*Enter Valid fax, Enter 10 digit</p>
                                      </span>
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-lg-5">
                            <label>FMS Fee
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="number" formControlName="fmsFee" class="form-control"
                                [(ngModel)]="savefmsagecy.fmsFee" />
                        </div>
                    </div>
                    
                 </form>
             </div>
             <div class="modal-footer">
                 <button class="btn  btn-sm" (click)="SaveOrUpdateFms();" [disabled]="!FmsForm.valid || isSaveorUpdateBoolean"><span
                         *ngIf="FmsType == 'CreateFmsModal'"> Save &
                         Close</span> <span *ngIf="FmsType == 'UpdateFmsModal'">Update & Close</span> </button>
                 <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
                     (click)="clearfms('cancel')">Cancel</button>
             </div>
         </div>
     </div>
 </div>
 <!-- For Delete Modal -->
 <span id="closeListModal" data-bs-target="#DeleteFmsmodal" data-bs-toggle="modal"></span>
 <div class="modal fade" id="DeleteFmsmodal" data-bs-backdrop="static">
     <div class="modal-dialog delete-zip" role="document">
         <div class="modal-content">
             <div class="modal-header">
                 <h5 class="modal-title font-header">Delete Record</h5>
                 <button type="button" class="btn-close" data-bs-dismiss="modal"
                 (click)="clearfms('cancel')" aria-label="Close">
                     <span aria-hidden="true"></span>
                 </button>
             </div>
             <div class="modal-body">
                 <div class="row">
                     <div class="col-lg-12">
                         <label>Do you want to delete this record ?</label>
                     </div>
                 </div>
             </div>
             <div class="modal-footer">
                 <button type="button" class="btn blue-btn btn-sm" (click)="DeleteFms()">Yes</button>
                 <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" 
                 (click)="clearfms('cancel')">No</button>
             </div>
         </div>
     </div>
 </div>
 
   
    
 